import { Button } from "@/components/ui/button";
import { Stethoscope } from "@phosphor-icons/react";

export function TherapiesEmptyState({
  hasFilters,
  onClear,
}: {
  hasFilters: boolean;
  onClear: () => void;
}) {
  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-border/60 bg-muted/10 px-6 py-20 text-center">
      <div className="mb-5 flex size-16 items-center justify-center rounded-2xl bg-primary/8">
        <Stethoscope className="size-7 text-primary" />
      </div>
      <h3
        className="text-lg font-semibold text-foreground"
        style={{ fontFamily: "var(--font-heading)" }}
      >
        {hasFilters ? "Nema rezultata" : "Nema terapijskih sesija"}
      </h3>
      <p className="mt-1.5 max-w-sm text-sm text-muted-foreground">
        {hasFilters
          ? "Nema terapijskih sesija koje odgovaraju odabranim filterima. Pokušajte sa drugim kriterijima."
          : "Nema terapijskih sesija na platformi."}
      </p>
      {hasFilters && (
        <Button
          variant="outline"
          size="sm"
          onClick={onClear}
          className="mt-4"
        >
          Očisti filtere
        </Button>
      )}
    </div>
  );
}
